import {
  toggleLinks,
  initComponents,
  fixVH,
  scrollToLinks,
  markLazyLoadedImages,
  lazyLoadVideos, inFieldLabels, markScrolledDown, markScrollDirection, markItemsInViewport, markContainerParagraphs,
} from "@/utils";


const win = <any>window;
const $ = win.jQuery;

window.addEventListener('DOMContentLoaded', async () => {
  win.__webpack_public_path__ = (<any>window).siteOptions.themePath + '/js/public/';

  fixVH();
  lazyLoadVideos();
  inFieldLabels();
  markScrolledDown(() => window.innerHeight / 2);
  markScrollDirection();
  markContainerParagraphs('.page__content');

  initComponents([
    'panel-toggle', 'menu-toggle', 'toggle-class', 'calculate-height',
    'swiper-slideshow', 'scroll-to',
    'moshik-scroll-animation',
  ]);

  document.documentElement.classList.add('is-loaded');
});


